var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":`slide-${_vm.direction}`}},[_c('section',{key:_vm.computedId,staticClass:"w-full relative h-full shrink-0",class:[
			{ hidden: !_vm.isActive || _vm.isDisabled },
			_vm.noScroll ? 'overflow-y-hidden' : 'overflow-y-auto'
		],attrs:{"id":_vm.computedId,"aria-hidden":!_vm.isActive || _vm.isDisabled,"role":"tabpanel"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }